import React, { useEffect, useState } from "react";

// reactstrap components
import {
	Card,
	CardHeader,
	CardBody,
	Table,
	Row,
	FormGroup,
	Input,
	Label,
	Collapse,
	Col,
	Button
} from "reactstrap";
import { Link } from "react-router-dom";
import * as moment from "moment";

import { STATUS_LIST, DATE_FORMATS, PAGE_LIMIT, MESSAGES } from '../../configs/constant'

import { DEPARTMENT, CATEGORY, SCHEME } from '../../configs/urls'
import { getApi, deleteApi } from '../../services/api'

import Loader from '../../components/Loader'
import Toaster from "../../components/Toaster";

import './styles.css'
import { FaEdit } from 'react-icons/fa'
import axios from 'axios'

const SchemesList = () => {

	const [isRequesting, setIsRequesting] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [canShowLoadMore, setCanShowLoadMore] = useState(false)
	const [isFilterOpen, setIsFilterOpen] = useState(false)
	const [filterParams, setFilterParams] = useState({
		page: 0,
		size: PAGE_LIMIT,
	})
	const [schemes, setSchemes] = useState([])
	const [categories, setCategories] = useState([])
	const [departments, setDepartments] = useState([])


	useEffect(() => {
		getAllData()
	}, []);

	const getAllData = () => {
		setIsRequesting(true)
		const category = getApi(CATEGORY)
		const department = getApi(DEPARTMENT)
		const scheme = getApi(SCHEME, filterParams)

		axios.all([category, department, scheme]).then(res => {
			if (res[0] && res[0].data) {
				setCategories(res[0].data)
			}

			if (res[1] && res[1].data) {
				setDepartments(res[1].data)
			}

			if (res[2] && res[2].data) {
				setSchemes(res[2].data)
				setCanShowLoadMore(res[2].data.length < res[2].meta.total)
			}
		}, (err) => {
			console.log(err);
		}).finally(() => {
			setIsRequesting(false);
		})
	}

	const fetchSchemes = (isLoadMore) => {
		setIsLoading(true);

		const params = JSON.parse(JSON.stringify(filterParams))

		for (const key in params) {
			if ((!params[key] && params[key] != 0) || params[key] == -1) {
				delete params[key]
			}
		}

		getApi(SCHEME, params)
			.then((res) => {
				isLoadMore ? setSchemes([...schemes, ...res.data]) : setSchemes(res.data || [])
				setCanShowLoadMore([...schemes, ...res.data].length < res.meta.total)
			}, (err) => {
				console.log(err);
			}).finally(() => {
				setIsLoading(false);
			})
	}

	const deleteScheme = (scheme_id) => {
		var proceed = window.confirm("Are you sure you want to delete Scheme?");
		if (proceed) {
			deleteApi(`${SCHEME}/${scheme_id}`)
				.then((res) => {
					let list = schemes
					list = list.filter(item => item.id != scheme_id)
					setSchemes(list)
					Toaster.showSuccess(res.message || 'Scheme deleted successfully.')
				}, (err) => {
					Toaster.showError(err.message)
				})
		}
	}

	const handleChange = (event) => {
		event.persist();
		setFilterParams(values => ({ ...values, [event.target.name]: event.target.value }));
	};

	const resetFilter = () => {
		setFilterParams({
			status: -1,
			department_id: -1,
			category_id: -1,
			name: '',
			page: 0,
			size: PAGE_LIMIT
		})

		fetchSchemes();
	}

	const loadMoreSchemes = () => {
		const params = filterParams;
		params.page++;

		setFilterParams(params)

		fetchSchemes(true)
	}

	const renderDepartments = () => (
		<div className="content">
			<Row>
				<Col md="12">
					<Card>
						<CardHeader className="header-section">
							<div>
								<Button color="primary" onClick={() => setIsFilterOpen(!isFilterOpen)}>Filter</Button>
							</div>
							<Link to="schemes/operations">
								<Button color="primary" className="text-right">Add New Scheme</Button>
							</Link>
						</CardHeader>

						<Collapse isOpen={isFilterOpen} className="border-top">
							<Card>
								<CardBody>
									<Row>
										<Col className="pr-1" md="3">
											<FormGroup>
												<Label for="departmentName">Department</Label>
												<Input
													type="select"
													name="department_id"
													value={filterParams.department_id}
													onChange={handleChange}
												>
													<option value={-1}>Select Department</option>
													{
														departments.map(department => (
															<option key={department.id} value={department.id}>{department.name}</option>
														))
													}
												</Input>
											</FormGroup>
										</Col>
										<Col className="pr-1" md="3">
											<FormGroup>
												<Label for="CategoryName">Category</Label>
												<Input
													type="select"
													name="category_id"
													value={filterParams.category_id}
													onChange={handleChange}
												>
													<option value={-1}>Select Category</option>
													{
														categories.map(category => (
															<option key={category.id} value={category.id}>{category.name}</option>
														))
													}
												</Input>
											</FormGroup>
										</Col>
										<Col className="pr-1" md="3">
											<FormGroup>
												<label>Scheme</label>
												<Input
													type="text"
													name="name"
													placeholder="Scheme Name"
													value={filterParams.name || ""}
													onChange={handleChange}
												/>
											</FormGroup>
										</Col>

										<Col className="pr-1" md="3">
											<FormGroup>
												<Label for="status">Status</Label>
												<Input
													type="select"
													name="status"
													value={filterParams.status}
													onChange={handleChange}
												>
													{
														STATUS_LIST.map(status => (
															<option key={status.id} value={status.id}>{status.title}</option>
														))
													}
												</Input>
											</FormGroup>
										</Col>

										<Col className="pr-1" md="4">
											<div className="update ml-auto mt-3 mr-auto">
												<Button className="btn-round" onClick={() => fetchSchemes()} color="primary">
													Search
												</Button>
												<Button className="btn-round ml-2" onClick={() => resetFilter()} color="primary">
													Reset
												</Button>
											</div>
										</Col>
									</Row>
								</CardBody>
							</Card>
						</Collapse>

						<hr />

						<CardBody>
							<Table>
								<thead className="text-primary">
									<tr>
										<th>ID</th>
										<th>Scheme Name</th>
										<th>Department</th>
										<th>category</th>
										<th>Status</th>
										<th>Last Update</th>
										<th className="text-right">Actions</th>
									</tr>
								</thead>
								<tbody>
									{
										schemes.map((scheme, key) => (
											<tr key={key}>
												<td>{scheme.id}</td>
												<td>{scheme.name || '--'}</td>
												<td>{scheme.department ? scheme.department.name : '--'}</td>
												<td>{scheme.category ? scheme.category.name : '--'}</td>
												<td>{scheme.status == 1 ? 'Enabled' : 'Disabled'}</td>
												<td>{scheme.updated_at ? moment(scheme.updated_at).format(DATE_FORMATS.DATE_TIME_FORMAT) : '--'}</td>
												<td className="text-right action-icons">
													<Link to={`schemes/operations/${scheme.id}`}>
														<FaEdit />
													</Link>
												</td>
											</tr>
										))
									}
								</tbody>
							</Table>
							{
								schemes.length == 0 &&
								<span className="no-record-found">{MESSAGES.NO_RECORD_FOUND}</span>
							}
						</CardBody>
					</Card>
				</Col>
			</Row>
			{
				canShowLoadMore && 
				<Row>
					<Col className="load-more-col">
						<Button className="action-btn" onClick={() => loadMoreSchemes()} color="primary">Load more</Button>
					</Col>
				</Row>
			}
			<Loader isLoading={isLoading} />
		</div>
	)

	return (
		<>
			{
				isRequesting
					? <div className="content"><Loader isLoading={isRequesting} /></div>
					: renderDepartments()
			}
		</>
	);
}

export default SchemesList;
